// src/pages/BlogPage/BlogPage.jsx
import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/customer/blogs/BlogPage.css";
import MyNavbar from "../../../components/general/navbar/MyNavbar";
import BlogCard from "../../../components/customer/cards/blogCard/BlogCard";
import Footer from "../../../components/general/footer/Footer";
import { BlogSectionSkeleton } from "../../../components/general/skeleton/SkeletonBlock";
import plants from "../../../assets/images/products/plants.jpg";
import axios from "axios";
import Swal from "sweetalert2";
import MyContext from "../../../context/MyContext";
const BlogPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { baseUrl, baseUrlForFiles } = useContext(MyContext);
  const [blogList, setBlogList] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const viewAllBlogs = () => {
    axios
      .get(`${baseUrl}/customer/blogs/viewAllBlogs`)
      .then((response) => {
        console.log(response.data);
        if (response.data.hasOwnProperty("error")) {
          setErrorMessage(response.data.error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error,
          });
        } else {
          setBlogList(response.data.blog);
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Blogs cannot load",
        });
      });
  };

  useEffect(() => {
    viewAllBlogs();
    setLoading(false);
  }, []);

  // const blogs = [
  //   {
  //     id: 5,
  //     image:
  //       "https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=800&q=80",
  //     title: "How to Apply Urea and DAP Fertilizer for Maximum Wheat Yield",
  //     date: "Thursday, Jan 23 2026",
  //     category: "Fertilizers",
  //   },
  //   {
  //     id: 6,
  //     image:
  //       "https://images.unsplash.com/photo-1628352081506-83c43123ed6d?w=800&q=80",
  //     title: "Weedicides in Cotton Fields: When and How to Use Topik Safely",
  //     date: "Wednesday, Jan 22 2026",
  //     category: "Weedicides",
  //   },
  //   {
  //     id: 10,
  //     image: plants,
  //     title:
  //       "Fresh Tomatoes & Chaunsa Mango: Seasonal Care Tips for Better Quality",
  //     date: "Saturday, Jan 18 2026",
  //     category: "Vegetables & Fruits",
  //   },
  // ];

  if (loading)
    return (
      <div className="blog-page">
        <section className="latest-blogs-section">
          <MyNavbar />
          <BlogSectionSkeleton />
        </section>
      </div>
    );

  return (
    <div className="blog-page">
      <MyNavbar />

      <section className="latest-blogs-section">
        <Container>
          {/* Section Header */}
          <div className="section-header">
            <div className="header-content">
              <p className="section-subtitle">Latest Updates</p>
              <h2 className="section-title">Latest Blogs</h2>
              <p className="header-description">
                Fresh insights and knowledge about our products to help you make
                better farming decisions
              </p>
            </div>
          </div>

          {/* Blog Grid */}
          <Row className="g-4 blog-grid">
            {blogList.map((blog) => (
              <Col key={blog.id} xs={12} sm={6} lg={4}>
                <BlogCard
                  blog={{
                    ...blog,
                    image: `${baseUrlForFiles}/${blog.image}`,
                  }}
                  // onClick={() => navigate(`/blog/${blog.slug}`)}
                />
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
